import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cOrgDtl from './cOrgDtl';

export default class iOrgDtl extends cOrgDtl {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stgs ={
  }

  $id_stss = {
  };

  $ilp_loads = () => [
    cp.$cp_hlr_cm31({
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
      cnd: bf.q('')
    })
  ];

  $ilp_upds = () => [
  ];

  render() {
//        b_rhtVsb={bf.i(global.c?.state.sgc_cm10c410, ['20', '90']) ? true : false}
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        rhtIconName={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        d_hdrs={{
          pfx: iv._get_hdrPfx('部門情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={ic.gn_maxBdyW}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm30c310',
              pfx:'部門名',
              b_mln:false,
            },
            {
              type: 'Clds',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'sld_cm31ss',
              pfx:'部門運営者',
              d_insDats: {
                cm31c410: '20',
              },
              dd_defss: {
                cm31b31k: {
                  type: 'Pck',
                  b_vsb: true,
                  b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                  pfx:'',
                  ld_iss: global.c?.state.sld_cm10ss,
                  onCls:null,
                  onChg:null,
                  b_dlt: true,
                },
              },
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm30cw10',
              pfx:'部門ID',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm30cx10',
              ini: '9999',
              pfx:'表示順　※全社運営者のみ表示',
              b_mln:false,
            },
/*
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm30cz10',
              ini: '10',
              pfx:'削除区分　※全社運営者のみ表示',
              ld_iss: [
                {key:'10', pfx: '削除しない'},
                {key:'0', pfx: '削除する'},
              ],
            },
*/
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_cm30cz10',
              ini: '10',
              pfx:'表示区分　※全社運営者のみ表示',
              ld_iss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
            },
          ],
        }}
      />
    );
  };
};
